"use client";

import { AddressFieldsForm } from "@/forms/address/AddressFields";
import { getPostalCodeInformation } from "@/postal-codes/getPostalInformation";
import { type TransitionStartFunction, useEffect } from "react";
import { useFormContext } from "react-hook-form";

type CheckoutMeta = { type: "cart" } | { type: "subscription"; sku: string };

export function CheckoutAutofill({
  startTransition,
}: {
  startTransition: TransitionStartFunction;
  checkoutMeta: CheckoutMeta;
}) {
  const { setValue, watch } = useFormContext<AddressFieldsForm>();

  const [postalDeliveryCode, postalBillingCode] = watch([
    "delivery.postalCode",
    "billing.postalCode",
  ]);

  useEffect(() => {
    if (postalDeliveryCode && postalDeliveryCode.length === 4) {
      startTransition(async () => {
        const postalCodeInfo =
          await getPostalCodeInformation(postalDeliveryCode);

        if (postalCodeInfo?.city) {
          setValue(`delivery.city`, postalCodeInfo.city);
        }
      });
    }
  }, [postalDeliveryCode, setValue, startTransition]);

  useEffect(() => {
    if (postalBillingCode && postalBillingCode.length === 4)
      startTransition(async () => {
        const postalCodeInfo =
          await getPostalCodeInformation(postalBillingCode);
        if (postalCodeInfo?.city) setValue(`billing.city`, postalCodeInfo.city);
      });
  }, [postalBillingCode, setValue, startTransition]);
  return null;
}
